module.exports = __webpack_public_path__ + "static/img/公司图片.3d2c483.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公司图片.jpeg
// module id = OgGh
// module chunks = 0